import { InjectionToken } from '@angular/core';

export interface MsalConfiguration {
  isMsalActivated: boolean;
  msalClientId: string;
  msalAuthority: string;
}

export const APP_MSAL_CONFIG: InjectionToken<MsalConfiguration> = new InjectionToken<MsalConfiguration>('APP_MSAL_CONFIG');
